import React from "react";
import error from "../assets/image/error.webp";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Error404() {
    return (
    <>
      <Navbar />
      <div className="error-container">
        <img src={error} alt="404 Page Not Found" className="error-image" />
        <p className="error-text">
          The page you're looking for doesn't exist or may have been moved.
        </p>

        <a href="/" className="error-button">
          ⬅ Back to Home
        </a>
      </div>
      <Footer />
    </>
  );
}
